export default __webpack_public_path__ + "static/media/13_2.1727da59.jpg";